import { Pipe, PipeTransform } from "@angular/core";
import { OrderPaymentStatusEnum } from "@models/order";

@Pipe({
  name: "orderPaymentStatus",
  standalone: true,
})
export class OrderPaymentStatusPipe implements PipeTransform {
  transform(value: OrderPaymentStatusEnum | string): string {
    switch (value) {
      case OrderPaymentStatusEnum.Paid:
        return "Pago";
      case OrderPaymentStatusEnum.Processing:
        return "Processando pagamento";
      case OrderPaymentStatusEnum.Refused:
        return "Recusado";
      case OrderPaymentStatusEnum.Pending:
      case OrderPaymentStatusEnum.WaitingPayment:
        return "Aguardando pagamento";
      case OrderPaymentStatusEnum.Canceled:
        return "Cancelado";
      case OrderPaymentStatusEnum.Refunded:
        return "Reembolsado";
      case OrderPaymentStatusEnum.Expired:
        return "Pagamento expirado";
      case OrderPaymentStatusEnum.Courtesy:
        return "Cortesia";
      case OrderPaymentStatusEnum.Failed:
        return "Falhou";
      case OrderPaymentStatusEnum.Transferred:
        return "Transferido";
      case OrderPaymentStatusEnum.RefundRequested:
        return "Cancelamento em análise";
      case OrderPaymentStatusEnum.RefundRejected:
        return "Reembolso Não Autorizado";

      case "approved":
        return "Aprovado";
      case "waiting":
        return "Aguardando pagamento";
      case "unpaid":
        return "Pagamento expirado";
      case "ATIVA":
        return "Aguardando pagamento";
      case "CONCLUIDA":
        return "Pago";

      default:
        return value;
    }
  }
}
